import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/icons/onboarding.png';
const _hoisted_1 = {
  class: "section-padding pt-0 horizontal-accordion bg-light-gray mt-4"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "28px",
    "height": "28px"
  },
  class: "mr-2",
  alt: ""
}, null, -1);
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "col-lg-8 col-12"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mt-2"
};
const _hoisted_8 = {
  class: "pl-4 pr-4 pt-3 pb-4 mt-3 border-radius-20 dashboard-card"
};
const _hoisted_9 = {
  class: "mb-4"
};
const _hoisted_10 = {
  class: "col-lg-4 col-12"
};
const _hoisted_11 = {
  class: "row mt-4"
};
const _hoisted_12 = {
  class: "col-12"
};
const _hoisted_13 = {
  class: "pl-4 pr-4 pt-4 pb-4 border-radius-20 dashboard-card",
  style: {
    "min-height": "300px"
  }
};
const _hoisted_14 = {
  class: "d-flex flex-row mb-2 mt-1"
};
const _hoisted_15 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
const _hoisted_17 = {
  style: {
    "line-height": "2",
    "color": "rgba(16,27,82,0.8)"
  },
  class: "pl-2"
};
const _hoisted_18 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_19 = ["href"];
const _hoisted_20 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_21 = ["href"];
const _hoisted_22 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_25 = ["href"];
const _hoisted_26 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_27 = ["href"];
const _hoisted_28 = {
  class: "col-12"
};
const _hoisted_29 = {
  class: "pl-4 pr-4 pt-4 pb-4 border-radius-20 dashboard-card mt-3",
  style: {
    "min-height": "300px"
  }
};
const _hoisted_30 = {
  class: "d-flex flex-row mb-2 mt-1"
};
const _hoisted_31 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
const _hoisted_33 = {
  style: {
    "line-height": "2",
    "color": "rgba(16,27,82,0.8)"
  },
  class: "pl-2"
};
const _hoisted_34 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_35 = ["href"];
const _hoisted_36 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_37 = ["href"];
const _hoisted_38 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_39 = ["href"];
const _hoisted_40 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_41 = ["href"];
const _hoisted_42 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_43 = ["href"];
const _hoisted_44 = {
  class: "fw-medium fsi-14 cursor-pointer"
};
const _hoisted_45 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_page_head = _resolveComponent("page-head");
  const _component_SearchNode = _resolveComponent("SearchNode");
  const _component_NodeInfo = _resolveComponent("NodeInfo");
  const _component_NodeInfo2 = _resolveComponent("NodeInfo2");
  const _component_NodeInfo3 = _resolveComponent("NodeInfo3");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_page_head, {
    showReturn: true,
    content: _ctx.$t('Onboarding.tips')
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.title')), 1)]),
    icon: _withCtx(() => [_hoisted_3]),
    _: 1
  }, 8, ["content"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_SearchNode, {
    ref: "searchNode",
    onReset: $options.resetNodeRes,
    onSearchFail: $options.resetNodeRes,
    onSearchOK: $options.searchNode
  }, null, 8, ["onReset", "onSearchFail", "onSearchOK"])]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_NodeInfo, {
    onNext: $options.nextFun,
    ref: "nodeInfo",
    "have-sp": $data.haveSp
  }, null, 8, ["onNext", "have-sp"])], 512), [[_vShow, $data.currentStep === 0]]), $data.currentStep === 1 ? (_openBlock(), _createBlock(_component_NodeInfo2, {
    key: 0,
    ref: "nodeInfo2",
    onNext: $options.nextFun,
    onPre: $options.preFun
  }, null, 8, ["onNext", "onPre"])) : _createCommentVNode("", true), $data.currentStep === 2 ? (_openBlock(), _createBlock(_component_NodeInfo3, {
    key: 1,
    onNext: $options.nextFun,
    onPre: $options.preFun,
    onBack: $options.back
  }, null, 8, ["onNext", "onPre", "onBack"])) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('FAQs.FAQs')), 1), _hoisted_16]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#wei-shen-me-yao-ru-zhi-jie-dian`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.Why node onboarding')), 9, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#wei-shen-me-yao-ru-zhi-jie-dian`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.What is required for node onboarding')), 9, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#jie-dian-neng-huo-de-duo-shao-dai-kuanedu`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.How much loan can a node get')), 9, _hoisted_23)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#bu-tong-wei-tuo-fang-shi-de-qu-bie`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.The difference between delegation methods')), 9, _hoisted_25)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#ru-he-shu-hui-jie-dian`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.How to redeem a node')), 9, _hoisted_27)])])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('FAQs.Additional Resources')), 1), _hoisted_32]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#stfil-de-jie-dai-ce-lve`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.STFILlending strategy')), 9, _hoisted_35)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/faq#guan-yu-li-lv-mo-xing`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.Lending Rate Model')), 9, _hoisted_37)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/shou-ba-shou-jiao-xue/ru-zhi-jie-dian#di-er-bu-she-zhi-jie-dian-cao-zuo-yuan`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.NodeOperator operation manual')), 9, _hoisted_39)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/shou-ba-shou-jiao-xue/ru-zhi-jie-dian#di-er-bu-she-zhi-jie-dian-cao-zuo-yuan`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.Debt interest calculation method')), 9, _hoisted_41)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/qing-suan`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.Debt liquidation')), 9, _hoisted_43)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("a", {
    target: "_blank",
    href: `${$options.docsUrlPrefix}leveraged-farming/kyc`,
    style: {
      "color": "rgba(16,27,82,0.8)"
    }
  }, _toDisplayString(_ctx.$t('FAQs.Storage provider KYC')), 9, _hoisted_45)])])])])])])])])]);
}